import script from "./CreateBannerAction.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateBannerAction.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__